import * as React from "react"
import About from "../components/mainPage/About"
import Ambassadors from "../components/mainPage/Ambassadors"
import Hero from "../components/mainPage/Hero"
import Layout from "../components/layout/Layout"
import ShortVideos from "../components/mainPage/ShortVideos"
import Seo from "../components/Seo"

const IndexPage = () => {
    return (
        <>
            <Seo title="Почетна" />
            <Layout>
                <Hero />
                <About />
                <Ambassadors />
                <ShortVideos />
            </Layout>
        </>
    )
}
export default IndexPage
